export function topPicksSlider() {
  function init() {
    const swiperSlider = new Swiper(".swiper-top-picks-slider", {
      enabled: true,
      updateOnWindowResize: true,
      freeMode: true,
      mousewheel: true,
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
      slidesPerView: "auto",
      breakpoints: {
        1180: {
          enabled: false,
        },
      },
    });
  }

  return {
    init,
  };
}
